import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 28 28" {...props}>
    <rect id="矩形_1102" data-name="矩形 1102" width="28" height="28" rx="10" fill="rgba(22,119,255,0.1)" />
    <path
      id="路径_6286"
      data-name="路径 6286"
      d="M24.445,23.326a.727.727,0,0,0,0-1.057l-3.737-3.522,3.737-3.522a.727.727,0,0,0,0-1.058l-.042-.039a.727.727,0,0,0-1,0l-3.8,3.581-3.8-3.581a.727.727,0,0,0-1,0l-.042.039a.727.727,0,0,0,0,1.058L18.5,18.747l-3.737,3.522a.727.727,0,0,0,0,1.057l.042.039a.727.727,0,0,0,1,0l3.8-3.581,3.8,3.581a.727.727,0,0,0,1,0Z"
      transform="translate(-5.286 -5.065)"
      fill="#0a1629"
      fill-rule="evenodd"
    />
  </svg>
);

export default CMP;
